import { NetworkConfiguration } from "../../network/networkConfriguation";
import { callAPI } from "../../network/networkConnection";

const addNewCategory = (payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADD_CATEGORY,
      "POST",
      {
        "Content-Type": "application/json",
      },
      payload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getExistingCategory = (query) => {
  const url = process.env.REACT_APP_APIUrl + NetworkConfiguration.EXISTING_CATEGORY + (query || "");
  return new Promise((resolve, reject) => {
    callAPI(
      url,
      "GET",
      {
        "Content-Type": "application/json",
      },
      null
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getExistingCategoryWithMapping = (query) => {
  const url = process.env.REACT_APP_APIUrl + NetworkConfiguration.EXISTING_CATEGORY + "?includeMapping=true" + (query || "");
  return new Promise((resolve, reject) => {
    callAPI(
      url,
      "GET",
      {
        "Content-Type": "application/json",
      },
      null
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const updateCategory = (payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.UPDATE_CATEGORY,
      "PUT",
      {
        "Content-Type": "application/json",
      },
      payload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
const createBlankCategoryContent = (payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.BLANK_CATEGORY_CONTENT,
      "POST",
      {
        "Content-Type": "application/json",
      },
      payload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const fetchGlobalCategory = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.GLOBAL_CATEGORY,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

const mapImporterrCategoryWithGlobalCategory = (payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.MAP_CATEGORY,
      "POST",
      {
        "Content-Type": "application/json",
      },
      payload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

const getCategoryMappings = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.EXISTING_CATEGORY + "/mappings",
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getCategoryDetails = (categoryId) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.EXISTING_CATEGORY + `/${categoryId}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getAllCategoriesForSkuUpload = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ALL_CATEGORIES_FOR_SKU_UPLOAD,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Fetch product count for a category (and its children)
const getCategoryProductCount = (categoryId) => {
  const url = process.env.REACT_APP_APIUrl + `admin/category/${categoryId}/product-count`;
  return new Promise((resolve, reject) => {
    callAPI(
      url,
      "GET",
      {
        "Content-Type": "application/json",
      },
      null
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Deep search categories by c_id or c_name across all nesting levels
const searchCategoriesDeep = (query) => {
  const url = process.env.REACT_APP_APIUrl + `admin/categories/search-deep?q=${encodeURIComponent(query)}`;
  return new Promise((resolve, reject) => {
    callAPI(
      url,
      "GET",
      {
        "Content-Type": "application/json",
      },
      null
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const categoryApiService = {
  addNewCategory,
  getExistingCategory,
  getExistingCategoryWithMapping,
  getCategoryMappings,
  updateCategory,
  createBlankCategoryContent,
  fetchGlobalCategory,
  mapImporterrCategoryWithGlobalCategory,
  getCategoryDetails,
  getAllCategoriesForSkuUpload,
  getCategoryProductCount,
  searchCategoriesDeep
};
